<template>
  <div
    v-for="(highlight, i) in highlightedProducts"
    :key="`highlight-${i}`"
    class="highlighted-products grid grid-cols-2"
  >
    <ProductItem
      v-for="productHandle in highlight.products"
      :key="`highlight-${productHandle}`"
      :product="findProduct(productHandle)"
      :highlighted-product="true"
    />

    <div
      v-if="highlight.products.length === 1"
      class="highlighted-products__media flex items-center justify-center"
    >
      <div class="inner video-ui">
        <video
          v-if="highlight.ugcVideo"
          width="530"
          height="528"
          preload="none"
          loop
          :poster="highlight.ugcImage"
        >
          <source
            :src="highlight.ugcVideo"
            type="video/mp4"
          >
          Your browser does not support the video tag.
        </video>
        <VideoPlay class="video-ui__play">
          <PlayIcon />
        </VideoPlay>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useCollectionStore } from '../pinia/CollectionStore'

import ProductItem from '../components/product-item'

import VideoPlay from '../components/video-play'
import PlayIcon from '../icons/play-icon'

export default {
  components: {
    ProductItem,
    VideoPlay,
    PlayIcon
  },
  props: {
    index: {
      type: Number,
      default: 99
    }
  },
  computed: {
    ...mapState (useCollectionStore, [
      'collection',
      'highlightedProducts',
    ]),
  },
  methods: {
    findProduct (handle) {
      return this.collection.products.find(product => product.handle === handle)
    }
  }
}
</script>
